export const environment = {
  production: true,
  host: 'https://polar.senzmate.com/service',
  googleMapKey: 'AIzaSyAca9W5Y8feCn8ni1s7jV7tjPICtWcMvD8'
};
